import { render, staticRenderFns } from "./Village.vue?vue&type=template&id=3acfd66f&"
import script from "./Village.vue?vue&type=script&lang=js&"
export * from "./Village.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports